import FirebaseContext, { withFirebase } from "./context";
import Firebase from "./firebase";
import useUserDetails from "./hooks";

export default Firebase;

export { FirebaseContext, withFirebase, useUserDetails };

